/**
 * 場所検索に足す語の入力
 *
 * 「なるさわ」だけで検索すると道の駅以外がヒットしてしまうため、共通の語を前後に足せるようにする。
 * 入力画面と確認① の両方から使うので切り出している。
 */

import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'

type Props = {
  prefix: string
  suffix: string
  onPrefixChange: (value: string) => void
  onSuffixChange: (value: string) => void
  /** id の衝突を避けるための接頭辞。同一画面に 2 つ置かない前提だが念のため分ける */
  idPrefix?: string
}

export const ImportSearchAffixFields = ({
  prefix,
  suffix,
  onPrefixChange,
  onSuffixChange,
  idPrefix = 'import-affix',
}: Props) => (
  <div className="space-y-2">
    <Label>場所検索に足す語（任意）</Label>
    <div className="flex items-center gap-2">
      <Input
        id={`${idPrefix}-prefix`}
        value={prefix}
        onChange={(e) => onPrefixChange(e.target.value)}
        placeholder="道の駅"
        aria-label="前に足す語"
      />
      <span className="shrink-0 text-xs text-muted-foreground">スポット名</span>
      <Input
        id={`${idPrefix}-suffix`}
        value={suffix}
        onChange={(e) => onSuffixChange(e.target.value)}
        placeholder="城"
        aria-label="後ろに足す語"
      />
    </div>
    <p className="text-xs text-muted-foreground">
      スポット名だけだと別の施設に当たることがあります。「道の駅」のような共通の語を入れると精度が上がります。
      名前に既に含まれている場合は足しません。
    </p>
  </div>
)
